import { ref } from 'vue';
import { defineStore } from 'pinia';

const useVideosStore = defineStore('videos', () => {
  // Store.
  const YT = ref(null);
  const videos = ref([]);
  const players = ref({});
  const isPlaying = ref(false);

  // Getters.

  // Actions.
  const initYT = () => {
    window.onYouTubeIframeAPIReady = () => {
      YT.value = window.YT;
      createPlayers();
    };
  };

  const addVideo = (id, videoId, playerReadyCallback) => {
    videos.value = [...videos.value, { id, videoId, playerReadyCallback }];
  };

  const createPlayers = () => {
    videos.value.forEach((video) => {
      // Create a video player and add it to the store.
      players.value[video.id] = new YT.value.Player(video.id, {
        videoId: video.videoId,
        autoPlay: false,
        host: `${window.location.protocol}//www.youtube-nocookie.com`,
        playerVars: {
          origin: `${window.location.origin}`,
          host: `${window.location.protocol}//www.youtube-nocookie.com`,
        },
        events: {
          onReady: video.playerReadyCallback,
          onStateChange: onPlayerStateChange,
        },
      });
    });
  };

  const onPlayerStateChange = (event) => {
    if (event.data === YT.value?.PlayerState.PLAYING) {
      isPlaying.value = true;
    }

    if (
      event.data === YT.value?.PlayerState.PAUSED ||
      event.data === YT.value?.PlayerState.ENDED
    ) {
      isPlaying.value = false;
    }
  };

  return {
    YT,
    videos,
    players,
    isPlaying,
    initYT,
    addVideo,
  };
});

export default useVideosStore;
